module.exports = __webpack_public_path__ + "static/img/16.6dc457b5.jpg";